import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "ease-in-out duration-500",
    "leave-active-class": "ease-in-out duration-500",
    "enter-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
        class: _normalizeClass([_ctx.toastClass, "fixed top-20 inset-x-4 md:inset-x-10 z-50 p-4 mb-2 rounded-lg shadow-lg cursor-pointer pointer-events-auto"])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.description), 1)
      ], 2), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 1
  }))
}